$(document).ready(function () {

    let relatedProductsSliderOptions = {

        infinite: true,
        dots: false,
        mobileFirst: true,

        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: $(".js-related-Product__slider").find(".js-related-Product__slide").length > 4 ? 5 : $(".js-related-Product__slider").find(".js-related-Product__slide").length,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: true,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                }
            }
        ]
    };



    $(".js-related-Product__slider").each(function () {

        if ($(this).hasClass("inizialized")) return;

        if ($(this).find(".js-related-Product__slide").length > 3) {

            $(this).slick(relatedProductsSliderOptions);

            $(this).addClass("inizialized");

        }else{
            $(".slider-cards-component__slide").addClass("width-no-slider")
        }

    });

})